import styled from 'styled-components';
import { colors } from '../colors';

const DropdownIcons = styled.div`
	transition: ease-in all 0.4s;
	padding: 0;
	align-items: center;
	border: 1px solid transparent;
	width: 57px;
	height: 57px;
	border-radius: 4px;
	color: ${colors.BlueBase};
	position: relative;
	float: left;
	display: flex;
	align-items: center;
	justify-content: center;
	:hover {
		background: ${colors.GreyEC};
		cursor: pointer;
	}
	span {
		font-size: 40px;
	}
`;

export default DropdownIcons;
